import React, { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ProfileGate from './ProfileGate';

interface Props {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const auth = useAuth();
  if (!auth || !auth.token) {
    return <Navigate to="/login" replace />;
  }
  return <ProfileGate>{children}</ProfileGate>;
};

export default ProtectedRoute;
